import { render, staticRenderFns } from "./WindowSidebarMenu.vue?vue&type=template&id=26509319&scoped=true&"
import script from "./WindowSidebarMenu.vue?vue&type=script&lang=js&"
export * from "./WindowSidebarMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26509319",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26509319')) {
      api.createRecord('26509319', component.options)
    } else {
      api.reload('26509319', component.options)
    }
    module.hot.accept("./WindowSidebarMenu.vue?vue&type=template&id=26509319&scoped=true&", function () {
      api.rerender('26509319', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/Sidebar/SidebarComponents/WindowSidebarMenu.vue"
export default component.exports